import template from './eea_report_help.html';
import * as Utils from '../../../lib/savanna_utils.js';

class EEAReportHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	}
};

class EEAReportHelpPage
{
	constructor (bindings)
	{
		this.viewModel = new EEAReportHelpViewModel(this);
		this.bindings = bindings;
		const tr = Utils.get_translator('default');
	};

	init()
	{
		Utils.refresh_data_visible_roles();
	}
};

export default {
	name: 'EEAReportHelp',
	dialog_class: EEAReportHelpPage,
	template: template,
	template_filename: 'translation/dialogs/eea_report_help',
	provider: 'ps'
};
